import { useState } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import Sidebar, { NAV_ITEMS } from "./Sidebar";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "./ui/sheet";
import { useAuth } from "@/lib/auth";
import { Menu, LogOut } from "lucide-react";

export default function AppShell() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen bg-slate-50">
      <Sidebar />
      {/* mobile top bar + drawer — the sidebar is hidden below lg */}
      <div className="lg:hidden sticky top-0 z-40 bg-slate-950 text-slate-100 flex items-center justify-between px-4 py-3 border-b border-slate-800" data-testid="mobile-topbar">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-blue-600 flex items-center justify-center font-bold text-white text-sm">A</div>
          <span className="font-heading font-bold">ASFA</span>
        </div>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button data-testid="mobile-menu-btn" aria-label="Open menu" className="p-2 rounded-lg hover:bg-slate-800">
              <Menu className="w-5 h-5" />
            </button>
          </SheetTrigger>
          <SheetContent side="left" className="bg-slate-950 text-slate-100 border-slate-800 w-72 p-0" data-testid="mobile-nav">
            <SheetTitle className="sr-only">Navigation menu</SheetTitle>
            <div className="px-5 py-5 border-b border-slate-800 flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-blue-600 flex items-center justify-center font-bold text-white text-sm">A</div>
              <div>
                <div className="font-heading font-bold">ASFA</div>
                <div className="text-xs text-slate-400">AI Receptionist</div>
              </div>
            </div>
            <nav className="px-3 py-4 space-y-0.5 overflow-y-auto max-h-[calc(100vh-140px)]">
              {NAV_ITEMS.map((it) => (
                <NavLink key={it.to} to={it.to} end={it.end} data-testid={`m-${it.tid}`} onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                      isActive ? "bg-blue-600 text-white" : "text-slate-300 hover:bg-slate-800 hover:text-white"
                    }`
                  }>
                  <it.icon className="w-4 h-4" />
                  {it.label}
                </NavLink>
              ))}
            </nav>
            <div className="px-5 py-4 border-t border-slate-800">
              <div className="text-xs text-slate-400 mb-2 truncate">{user?.email}</div>
              <button data-testid="m-logout-btn" onClick={() => { setOpen(false); logout(); nav("/"); }}
                className="flex items-center gap-2 text-sm text-slate-300 hover:text-white">
                <LogOut className="w-4 h-4" /> Sign out
              </button>
            </div>
          </SheetContent>
        </Sheet>
      </div>
      <main className="lg:pl-64">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
